
export const ACTION = {
    STATUTORY_LIST: 'STATUTORY_LIST',
    GET_DESIGNATED_EMPLOYEE_DATA_NEW: 'GET_DESIGNATED_EMPLOYEE_DATA_NEW',
    STATUTORY_RISKOMETER: 'STATUTORY_RISKOMETER',
    STATUTORY_VALUATION: 'STATUTORY_VALUATION',
    STATUTORY_SCHEME_FINANCE: 'STATUTORY_SCHEME_FINANCE',
    STATUTORY_COMMISSION: 'STATUTORY_COMMISSION',
    STATUTORY_AUM: 'STATUTORY_AUM',
    STATUTORY_VOTING: 'STATUTORY_VOTING',
    STATUTORY_ABRIDGED: 'STATUTORY_ABRIDGED',
    STATUTORY_ABRIDGE_FILLTER: 'STATUTORY_ABRIDGE_FILLTER',
    STATUTORY_AVERAGE_PORTFOLIO: 'STATUTORY_AVERAGE_PORTFOLIO',
    MANDATORY_INVESTMENT: 'MANDATORY_INVESTMENT',
    STATUTORY_MONTHS_FILLTER: 'STATUTORY_MONTHS_FILLTER',
    STATUTORY_TRADE: 'STATUTORY_TRADE',
    STATUTORY_MONTH_YEAR_PORTFOLIO: 'STATUTORY_MONTH_YEAR_PORTFOLIO',
    STATUTORY_PORTFOLIO_MONTH: 'STATUTORY_PORTFOLIO_MONTH',
    STATUTORY_SEARCH: 'STATUTORY_SEARCH',
    STATUTORY_TRACKING_ERROR: 'STATUTORY_TRACKING_ERROR',
    STATUTORY_ANNUAL_REPORT:'STATUTORY_ANNUAL_REPORT',
    GET_TER_NEW_COMMON:'GET_TER_NEW_COMMON',
    GET_TER_NOTICE_CONTENT:'GET_TER_NOTICE_CONTENT',
    GET_TER_REPORT:'GET_TER_REPORT',
    GET_TER_MONTH:'GET_TER_MONTH',
    STATUTORY_STEWARDSHIP: 'STATUTORY_STEWARDSHIP',
    GET_REMUNERATION_CONTENT: 'GET_REMUNERATION_CONTENT',
    STATUTORY_SCHEME_PERFORMANCE: 'STATUTORY_SCHEME_PERFORMANCE',
    PUBLIC_CAUTION_NOTICE_NEW:'PUBLIC_CAUTION_NOTICE_NEW',
    LETTER_UNIT_HOLDER:'LETTER_UNIT_HOLDER',
    SATURITY_COMPLAINTS:'SATURITY_COMPLAINTS',
    STATUTORY_INVESTOR_COMPLAINTS: 'STATUTORY_INVESTOR_COMPLAINTS',
    STATUTORY_INVESTOR_COMPLAINTS_PMS: 'STATUTORY_INVESTOR_COMPLAINTS_PMS',
    OFFER_DOCUMENTS:'OFFER_DOCUMENTS',
    STATUTORY_RISK_DISCLOSURES: 'STATUTORY_RISK_DISCLOSURES',
    DISTRIBUTOR_RELATED_EXPENSES: 'DISTRIBUTOR_RELATED_EXPENSES',
    MARKET_MAKER_PAGE: 'MARKET_MAKER_PAGE',
    PASSIVE_FUND_ETF: 'PASSIVE_FUND_ETF',
    STATUTORY_PASSIVE_FUND_MONTH: 'STATUTORY_PASSIVE_FUND_MONTH',
    DAILY_PERFORMANCE_IR: 'DAILY_PERFORMANCE_IR',
    STATUTORY_REPORT_MISSELLING_FUND: 'STATUTORY_REPORT_MISSELLING_FUND',
};


